/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { injectIntl } from "react-intl";
import { Alert } from "react-bootstrap";

class QuoteCustomForm extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();
        this.createDefaultSubject = props.compensation ? props.compensation.compensationnumber : "";
        const { fields } = this.props.workflowItem;

        this.createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };
        if (fields.Title.visible) {
            this.createFormConfig.fields.push({ label: fields.Title.label, dataField: 'quotereference', editorOptions: { defaultValue: this.createDefaultSubject } });
        }
        if (fields.Note.visible) {
            this.createFormConfig.fields.push({ note: fields.Note.label });
        }
        if (fields.ContinuingEffect.visible) {
            this.createFormConfig.fields.push({ label: fields.ContinuingEffect.label, dataField: "continuingeffect", editorType: 'dxSelectBox', editorOptions: { dataSource: fields.ContinuingEffect.continuingEffectOptions, valueExpr: 'value', displayExpr: 'display' } });
        }
        if (fields.Comments.visible) {
            this.createFormConfig.fields.push({ label: fields.Comments.label, dataField: 'quotecomment', editorType: 'dxHtmlEditor' });
        }
        if (fields.PriceEffect.visible) {
            this.createFormConfig.fields.push({ label: fields.PriceEffect.label, dataField: 'amount', editorType: 'dxNumberBox' });
        }
        if (fields.DateEffectOptions.visible) {
            this.createFormConfig.fields.push({ label: fields.DateEffectOptions.label, dataField: 'effect', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.DateEffectOptions.quoteImpactOptions, valueExpr: 'field', displayExpr: 'display' } });
        }
        if (fields.ProgrammeDetails.visible) {
            this.createFormConfig.fields.push({ label: fields.ProgrammeDetails.label, dataField: 'effecttoprogrammitigatedcomment', editorType: 'dxHtmlEditor', visible: (obj) => obj.effect === 'mitigated' || obj.effect === 'notmitigated' });
        }
        if (fields.DateEffect.visible) {
            this.createFormConfig.fields.push({ label: fields.DateEffect.label, dataField: 'days', editorType: 'dxNumberBox', editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }, visible: (obj) => obj.effect === 'notmitigated' });
        }
        if (fields.AttachedProgramme.visible) {
            this.createFormConfig.fields.push({ label: fields.AttachedProgramme.label, dataField: 'attachedprogramme', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.AttachedProgramme.options }, visible: (obj) => obj.effect === 'mitigated' || obj.effect === 'notmitigated' });
        }

        this.state = {
            isDxFormValid: true,
            contractSecondaryDates: null,
            contractOtherPrices: null
        };
    }


    render() {
        const { fields } = this.props.workflowItem;
        return (
            <>
                {this.props.resources.SupplierQuoteWarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.SupplierQuoteWarningBanner}
                        </p>
                    </Alert>
                )}

                <BiDynamicForm
                    validatorRef={this.validatorRef}
                    item={this.props.item}
                    config={this.createFormConfig}
                    onSubmitHandler={this.props.onSubmitHandler}
                    valueChangeHandler={this.props.valueChangeHandler}
                    customFields={this.props.customFields}
                    secondaryPriceSectionEnabled={this.props.compensation.clauseeffect !== "EFFECT_DATES_ONLY"}
                    secondaryDateSectionEnabled={this.props.compensation.clauseeffect !== "EFFECT_AMOUNTS_ONLY"}
                    taskorderid={this.props.compensation?.taskorderid}
                    projectorderid={this.props.compensation?.projectorderid}
                    interimQuotesAllowed={fields.ContinuingEffect.visible}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // contractTemplate: store.contract.template,
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(QuoteCustomForm)));
